angular.module('iqxCore')
.controller('ClientWelcomeCtrl', function ($scope, $routeParams, $location, $window) {
	$scope.navigate=function(n){
		$location.url(n)
	}

	$scope.slides=[]

	// contact details
	$scope.slides.push(
	  {
	    title:$scope.params.lang.client.details,
	    image:"/assets/welcome-page-images/clientContactDetails.png",
	    icon:"fa fa-pencil",
	    iconColor:"#ef9a9a",
	    list:[
	      {
	        title:false,
	        text:"Add all required details"
	      },
	      {
	        title:false,
	        text:"Update directly to IQX"
	      },
	      {
	        title:false,
	        text:"Edit details on the move"
	      }
	    ]
	  }
	)

	// Current requirements
	if($scope.userHasRight('CURRENTREQUIREMENTS')){
		$scope.slides.push(
		  {
		    title:$scope.params.lang.client.currentrequirements,
		    image:"/assets/welcome-page-images/clientCurrentRequirments.png",
		    icon:"fa fa-clipboard",
		    iconColor:"#7986CB",
		    list:[
		      {
		        title:false,
		        text:"Add a vacancy requirement"
		      },
		      {
		        title:false,
		        text:"Filter via a date range"
		      },
		      {
		        title:false,
		        text:"View vacancy details, shortlisted candidates and contact details"
		      },
		      {
		        title:false,
		        text:"Access candidate documents to start the compliance process"
		      }
		    ]
		  }
		)
	}

	// Timesheets
	if(true){
		$scope.slides.push(
		  {
		    title:"Timesheets",
		    image:"/assets/welcome-page-images/clientTimesheets.png",
		    icon:"fa fa-building",
		    iconColor:"#CE93D8",
		    list:[
		      {
		        title:false,
		        text:"Authorise and approve"
		      },
		      {
		        title:false,
		        text:"View candidate timesheets"
		      },
		      {
		        title:false,
		        text:"Access completed timesheets"
		      }
		    ]
		  }
		)
	}

	// Invoice
	if($scope.userHasRight('VIEWINVOICES')){
		$scope.slides.push(
		  {
		    title:$scope.params.lang.client.invoices,
		    image:"/assets/welcome-page-images/clientInvoices.png",
		    icon:"fa fa-file-text-o",
		    iconColor:"#FFCC80",
		    list:[
		      {
		        title:false,
		        text:"View and access invoice details"
		      },
		      {
		        title:false,
		        text:"Filter invoices by date range"
		      },
		      {
		        title:false,
		        text:"Quickly view invoice balance"
		      }
		    ]
		  }
		)
	}

	// Contacts
	if($scope.userHasRight('MAINTAINCONTACTS')){
		$scope.slides.push(
		  {
		    title:$scope.params.lang.client.contacts,
		    image:"/assets/welcome-page-images/clientContacts.png",
		    icon:"fa fa-users",
		    iconColor:"#A5D6A7",
		    list:[
		      {
		        title:false,
		        text:"Interact with the details"
		      },
		      {
		        title:false,
		        text:"Add internal contacts"
		      },
		      {
		        title:false,
		        text:"Contacts added in IQX will also show here"
		      }
		    ]
		  }
		)
	}


})
